import Vue from 'vue'
import Axios from 'axios'
import auth from './auth'
import config from './config'
import store from '../store'

export default {
  instance () {
    // console.log('new instance')
    var instance = Axios.create({
      baseURL: config.baseURL,
      headers: auth.getAuthHeader()
    })

    instance.interceptors.response.use((response) => {
      return response;
    }, (error) => {
      if (error.response && error.response.status === 500) {
        console.log('Your session has expired.');
        this.$router.push({ path: 'denied', query: { msg: 'Error 500' }})
      } else if (error.response && error.response.status === 403) {
        console.log('Your session has expired.');
        this.$router.push({ path: 'denied', query: { msg: 'Error 403' }})
      } else {
        return Promise.reject(error);
      }
    });

    Vue.prototype.$http = instance;
    return instance;

  }
}
